import axios from 'axios';
import qs from 'qs';

/**
 * Wrapper for any axios logic
 */
const ApiService = {
  token: null,

  init(BASE_URL) {
    axios.defaults.baseURL = BASE_URL;
    axios.defaults.withCredentials = true;
    axios.defaults.paramsSerializer = (params) =>
      qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true });
  },

  async getAndSetCsrfToken() {
    const csrfToken = await ApiService.get('/auth/get_csrf_token/');
    const token = csrfToken.data?.token;
    ApiService.token = token;
    axios.defaults.headers.common['X-CSRFToken'] = token;
  },

  async get(resource) {
    return await axios.get(resource);
  },
};

export default ApiService;
